import { render, staticRenderFns } from "./BankaHesapPlaniCreateOrUpdate.vue?vue&type=template&id=37e74fd3&"
import script from "./BankaHesapPlaniCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./BankaHesapPlaniCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports